import React, { useEffect, useState, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Search, X, TrendingUp, Clock } from 'lucide-react';
interface SearchOverlayProps {
  isOpen: boolean;
  onClose: () => void;
}
const trendingSearches = ['Minimalist interior', 'Abstract art', 'Plant decor', 'Workspace setup', 'Fashion trends 2025'];
const recentSearches = ['Mountain photography', 'Coffee aesthetic', 'Typography design'];
export function SearchOverlay({
  isOpen,
  onClose
}: SearchOverlayProps) {
  const [query, setQuery] = useState('');
  const inputRef = useRef<HTMLInputElement>(null);
  useEffect(() => {
    if (isOpen && inputRef.current) {
      inputRef.current.focus();
    }
  }, [isOpen]);
  if (!isOpen) return null;
  return <AnimatePresence data-id="element-315">
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} className="fixed inset-0 bg-black/40 backdrop-blur-sm z-50 md:hidden" onClick={onClose} data-id="element-316">
        <motion.div initial={{
        y: -20,
        opacity: 0
      }} animate={{
        y: 0,
        opacity: 1
      }} exit={{
        y: -20,
        opacity: 0
      }} className="bg-white w-full" onClick={e => e.stopPropagation()} data-id="element-317">
          <div className="flex items-center gap-3 p-4 border-b border-gray-100" data-id="element-318">
            <Search className="w-5 h-5 text-gray-400" data-id="element-319" />
            <input ref={inputRef} type="text" placeholder="Search for ideas" className="flex-1 text-base outline-none bg-transparent" value={query} onChange={e => setQuery(e.target.value)} data-id="element-320" />
            <button onClick={onClose} className="p-1" data-id="element-321">
              <X className="w-5 h-5 text-gray-500" data-id="element-322" />
            </button>
          </div>

          <div className="p-4 max-h-[70vh] overflow-y-auto" data-id="element-323">
            {recentSearches.length > 0 && <div className="mb-6" data-id="element-324">
                <h3 className="text-xs font-semibold text-gray-500 uppercase tracking-wider mb-3 flex items-center gap-2" data-id="element-325">
                  <Clock className="w-3 h-3" data-id="element-326" />
                  Recent
                </h3>
                <div className="space-y-1" data-id="element-327">
                  {recentSearches.map((search, i) => <button key={i} className="w-full text-left py-2 px-3 hover:bg-gray-50 rounded-lg text-sm text-gray-700 transition-colors" data-id="element-328">
                      {search}
                    </button>)}
                </div>
              </div>}

            <div data-id="element-329">
              <h3 className="text-xs font-semibold text-gray-500 uppercase tracking-wider mb-3 flex items-center gap-2" data-id="element-330">
                <TrendingUp className="w-3 h-3" data-id="element-331" />
                Trending
              </h3>
              <div className="space-y-1" data-id="element-332">
                {trendingSearches.map((search, i) => <button key={i} className="w-full text-left py-2 px-3 hover:bg-gray-50 rounded-lg text-sm text-gray-700 transition-colors" data-id="element-333">
                    {search}
                  </button>)}
              </div>
            </div>
          </div>
        </motion.div>
      </motion.div>
    </AnimatePresence>;
}